import styled from 'styled-components';

export const RowContainer = styled.div`
  display: flex;
  background: var(--color-greyF3);
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px;

  & > * {
    margin-right: 10px;

    :last-child {
      margin-right: 0;
    }
  }
`;

export const IdField = styled.span`
  display: inline-block;
  width: ${({ width }) => `${width}%`};
  height: 95px;
  border-bottom-left-radius: 8px;
  border-top-left-radius: 8px;
  background-color: var(--color-grey6A);
  font-size: var(--font-size23);
  letter-spacing: 0.1px;
  color: var(--color-white);
  padding: 10px 0 0 15px;
`;

export const Field = styled.span`
  width: ${({ width }) => `${width}%`};
  font-size: var(--font-size15);
  color: var(--color-grey6A);
  text-align: left;
  padding-top: 10px;
`;

export const DownloadWrapper = styled.div`
  width: ${({ width }) => `${width}%`};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 45px;
  height: 45px;
  border: 2px solid var(--color-green65);
  border-radius: 50%;
  background: none;
  outline: 0;
  cursor: pointer;
  &:disabled {
    opacity: 0.75;
    cursor: not-allowed;
  }
`;
